import { EVENT_CLOSE_MEGA_SHARE_FRIEND_DIALOG, EVENT_OPEN_MEGA_SHARE_FRIEND_DIALOG } from "./constants";

export const openMegaShareFriendDialog = () => {
  const event = new CustomEvent(EVENT_OPEN_MEGA_SHARE_FRIEND_DIALOG);
  window.dispatchEvent(event);
};

export const closeMegaShareFriendDialog = () => {
  const event = new CustomEvent(EVENT_CLOSE_MEGA_SHARE_FRIEND_DIALOG);
  window.dispatchEvent(event);
};
